import React from 'react'
import KeyDropdownValue from '../shared/KeyDropdownValue'
import { prefix } from '../normalizer'

const tRegister = prefix('gamification2026.register')

const CommercialManagerForm = ({ commercialManagers, onChangeCommercialManager }) => {
  const optionsWithLabel = (commercialManagers || []).map(cm => ({
    ...cm,
    display_label: `${cm.full_name} [${cm.email}]`
  }))

  return (
    <div className="register__section">
      <h3 className="register__section-title">{tRegister('commercial-manager-title')}</h3>
      <KeyDropdownValue
        title={tRegister('commercial-manager')}
        placeholder={tRegister('commercial-manager-placeholder')}
        name="commercial_manager_id"
        options={optionsWithLabel}
        optionsLabel="display_label"
        optionsId="id"
        onChange={onChangeCommercialManager}
      />
    </div>
  )
}

export default CommercialManagerForm
